import { APIErrorContext } from 'contexts/ErrorContext';
import { useContext } from 'react';

function useAPIError() {
    const { error, addError, removeError } = useContext(APIErrorContext);
    return { error, addError, removeError };
}

export default useAPIError;
